// ! just added updateShippingPrice

import BrowserDatabase from 'Util/BrowserDatabase';
import { getIndexedProduct } from 'Util/Product';

import { UPDATE_SHIPPING_PRICE, UPDATE_TOTALS } from './Cart.action';

export const CART_TOTALS = 'cart_totals';

const updateCartTotals = (action) => {
    const { cartData: cartTotals } = action;

    if (Object.hasOwnProperty.call(cartTotals, 'items')) {
        const normalizedItemsProduct = cartTotals.items.map((item) => {
            const normalizedItem = item;
            normalizedItem.product = getIndexedProduct(item.product);

            return normalizedItem;
        });

        cartTotals.items = normalizedItemsProduct;
    }

    BrowserDatabase.setItem(
        cartTotals,
        CART_TOTALS
    );

    return { cartTotals };
};

export const updateShippingPrice = (action, state) => {
    const {
        data: {
            shipping_amount,
            shipping_incl_tax
        } = {}
    } = action;

    return {
        cartTotals: {
            ...state.cartTotals,
            shipping_amount,
            shipping_incl_tax
        }
    };
};

export const initialState = {
    cartTotals: BrowserDatabase.getItem(CART_TOTALS) || {}
};

const CartReducer = (state = initialState, action) => {
    const { type } = action;

    switch (type) {
    case UPDATE_TOTALS:
        return updateCartTotals(action, state);
    case UPDATE_SHIPPING_PRICE:
        return updateShippingPrice(action, state);
    default:
        return state;
    }
};

export default CartReducer;
